import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiAxios from "helpers/apiAxios";
import { toast } from "react-toastify";

const periodUrl = "/erp/periods";

export const getPeriods = createAsyncThunk(
  "ERP_period/getPeriods",
  async (params) => {
    try {
      const response = await apiAxios.get(periodUrl, { params } )
      return response.data
    }
    catch(error) {
      throw new Error(error.message)
    }
  }
)

export const createPeriod = createAsyncThunk(
  "ERP_period/createPeriod",
  async (data, { rejectWithValue }) => {
    try {
      const response = await apiAxios.post(periodUrl, data)
      return response.data
    }
    catch(error){
      return rejectWithValue(error.response.data)
    }
  }
)

export const updatePeriod = createAsyncThunk(
  "ERP_period/updatePeriod",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await apiAxios.put(`${periodUrl}/${id}`, data)
      return response.data
    }
    catch(error) {
      return rejectWithValue(error.response.data);
    }
  }
)

export const deletePeriod = createAsyncThunk(
  "ERP_period/deletePeriod",
  async (id, { rejectWithValue }) => {
    try {
      await apiAxios.delete(`${periodUrl}/${id}`);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
)

const isRejectedAction = (action) => (action.type.startsWith("ERP_period/")) && action.type.endsWith("/rejected");

const periodSlice = createSlice({
  name: "erp_period",
  initialState: {
    items: [],
    total: 0,
    loading: false,
    error: null,
    gridParams: {
      page: 0,
      pageSize: 100,
      sortModel: [],
      filterModel: {}
    }
  },
  reducers: {
    setGridParams: (state, action) => {
      state.gridParams = { ...state.gridParams, ...action.payload };
    },
    clearError: (state) => {
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPeriods.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPeriods.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.rows || [];
        state.total = action.payload.total || 0;
      })
      .addCase(getPeriods.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addMatcher(
        isRejectedAction,
        (state, action) => {
          state.loading = false;
          toast.error(action.payload?.message || action.payload?.error || action?.error?.message)
        }
      );
  }
})

export const { setGridParams, clearError } = periodSlice.actions;
export default periodSlice.reducer